import styled from "@emotion/styled";
import { Badge } from "@mui/material";
import React from "react";
interface CustomBadgeProps {
  badgeContent: number;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  show?: boolean;
  tooltipwithborder?: boolean;
}
function BadgeCustom(props: CustomBadgeProps) {
  if (props?.show === false) return <></>;
  return (
    <CustomBadge
      {...props}
      style={{ width: "100%", ...props.style }}
      badgeContent={props.badgeContent ?? 0}
    >
      {props.children}
    </CustomBadge>
  );
}

export default BadgeCustom;

const CustomBadge = styled(Badge)<{ tooltipwithborder?: boolean }>`
  .MuiBadge-badge {
    background-color: var(--m-color-blue-01);
    color: var(--m-color-blue-03);
    font-size: 12px;
    ${props => props.tooltipwithborder && "border: 1px solid white"}
  }
`;
